import { TelemetryErrorBoundary as ErrorBoundary } from "@mixitone/telemetry";

const ErrorState = () => {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <p className="mb-4 text-lg font-medium">Something went wrong</p>
        <p className="text-sm text-gray-600">Please try again later</p>
      </div>
    </div>
  );
};

const StyledErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  return <ErrorBoundary fallback={<ErrorState />}>{children}</ErrorBoundary>;
};

export default StyledErrorBoundary;
